// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Prayer from "./pages/Prayer";
import AiFormPage from "./pages/AiFormPage";
import AboutUs from "./pages/AboutUs";
import PolicyPage from "./pages/PolicyPage";
import Members from "./pages/Members";
import LadyP from "./pages/LadyP";
import Media from "./pages/Media";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* About routes */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/aboutus" element={<Navigate to="/about" replace />} />

      <Route path="/prayer" element={<Prayer />} />
      <Route path="/ai" element={<AiFormPage />} />
      <Route path="/policy" element={<PolicyPage />} />
      <Route path="/members" element={<Members />} />
      <Route path="/ladyp" element={<LadyP />} />
      <Route path="/media" element={<Media />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}